import React from 'react';
import { getBeneficiaryIcon } from '../BeneficiaryMainCard';
import BeneficiarySection from '../BeneficiarySection';
import BeneficiarySingleValue from '../BeneficiaryValues/BeneficiarySingleValue';
import { MainCategoryProps } from '../MainCategory';
import {
  Beneficiaries,
  BeneficiaryTitleInfoProps,
} from '../utils/beneficiaryInterfaces';
import { beneficiaryTitle } from '../utils/helperComponents';

const minWidth = 256;

interface BeneficiarySocialProps extends BeneficiaryTitleInfoProps {
  beneficiary: Beneficiaries['social'];
  setBeneficiaries: MainCategoryProps['setBeneficiaries'];
}

const BeneficiarySocial: React.FC<BeneficiarySocialProps> = ({
  beneficiary,
  beneficiaryLabel,
  programName,
  setBeneficiaries,
}) => {
  if (beneficiary === undefined) return null;
  return (
    <BeneficiarySection
      icon={getBeneficiaryIcon('social')}
      setBeneficiaries={setBeneficiaries}
      category="social"
      heading="Social and economic status"
      title={beneficiaryTitle(
        'the Social and economic status',
        programName,
        beneficiaryLabel,
      )}
      note={undefined}
    >
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Immigrants, migrants, and refugees"
        buttonLabel="Immigrants, migrants, and refugees"
        inputLabel="Immigrants, migrants, and refugees"
        categoryName="social"
        category={beneficiary.categories}
        fieldName="Immigrants and migrants"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Economically disadvantaged people"
        buttonLabel="Economically disadvantaged people"
        inputLabel="Economically disadvantaged people"
        categoryName="social"
        category={beneficiary.categories}
        fieldName="Economically disadvantaged people"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Youth"
        buttonLabel="Youth"
        inputLabel="Youth"
        categoryName="social"
        category={beneficiary.categories}
        fieldName="At-risk youth"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Homeless people"
        buttonLabel="Homeless people"
        inputLabel="Homeless people"
        categoryName="social"
        category={beneficiary.categories}
        fieldName="Homeless people"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Extremely poor people"
        buttonLabel="Extremely poor people"
        inputLabel="Extremely poor people"
        categoryName="social"
        category={beneficiary.categories}
        fieldName="Extremely poor people"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Victims and oppressed people"
        buttonLabel="Victims and oppressed people"
        inputLabel="Victims and oppressed people"
        categoryName="social"
        category={beneficiary.categories}
        fieldName="Victims and oppressed people"
        setBeneficiaries={setBeneficiaries}
      />
      <BeneficiarySingleValue
        buttonMinWidth={minWidth}
        title="Incarcerated people"
        buttonLabel="Incarcerated people"
        inputLabel="Incarcerated people"
        categoryName="social"
        category={beneficiary.categories}
        fieldName="Incarcerated people"
        setBeneficiaries={setBeneficiaries}
      />
    </BeneficiarySection>
  );
};

export default React.memo(BeneficiarySocial);
